<template>
  <b-modal
    size="lg"
    v-model="modal"
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @hidden="$emit('cancel')"
    @ok.prevent="saveItem"
  >
    <div slot="modal-title" class="form-title">
      <div v-if="isEdit">
        <div id="title-modal">{{ titleModal }}</div>
        <div id="sub-title-modal">
          Nr systemowy:
          <div class="title-inline" v-if="systemModal">{{ systemModal }}</div>
          <div class="title-inline" v-if="!systemModal">brak</div>
        </div>
        <div id="sub-title-modal">
          Nr seryjny:
          <div class="title-inline" v-if="serialModal">{{ serialModal }}</div>
          <div class="title-inline" v-if="!serialModal">brak</div>
        </div>
      </div>
      <div v-if="!isEdit">
        <div id="title-modal">Dodaj wyposażenie</div>
      </div>
    </div>

    <div class="form-batch-top">Zakup</div>
    <hr class="mt-1 mb-4" width="94%" />
    <app-datepicker-col class="dateInput" :model="$schema.dateOfPurchase"></app-datepicker-col>
    <app-input-col :model="$schema.invoiceNumber"></app-input-col>
    <app-input-col :model="$schema.name"></app-input-col>
    <app-input-col :model="$schema.price"></app-input-col>
    <app-input-col :model="$schema.positionNumber"></app-input-col>

    <div class="form-batch">Szczegóły</div>
    <hr class="mt-1 mb-4" width="94%" />
    <div class="container-fluid form-container-fluid">
      <div class="row">
        <div class="col-4">
          <label>Rodzaj wyposażenia</label>
        </div>
        <div class="col-8">
          <b-form-group :state="stateType" :invalid-feedback="invalidType" :vaild-feedback="validType">
            <v-select class="float-left v-select-width" v-model="selectedType" label="text" :options="types" @input="setModelType"></v-select>
          </b-form-group>
        </div>
      </div>
    </div>
    <app-input-col :model="$schema.systemNumber" v-if="!isEdit"></app-input-col>
    <app-input-col :model="$schema.systemNumber" v-if="isEdit" :disabled="isEdit"></app-input-col>
    <app-input-col :model="$schema.serialNumber"></app-input-col>
    <app-textarea-col class="reason" :model="$schema.annotation"></app-textarea-col>

    <div class="form-batch">Likwidacja</div>
    <hr class="mt-1 mb-4" width="94%" />
    <app-checkbox-col :model="$schema.deleted"></app-checkbox-col>
    <app-datepicker-col v-show="$schema.$model.deleted" class="dateInput" :model="$schema.deleteDate"></app-datepicker-col>
    <app-textarea-col v-show="$schema.$model.deleted" class="reason" :model="$schema.deleteReason"></app-textarea-col>

    <div class="form-batch">Tagi</div>
    <hr class="mt-1 mb-4" width="94%" />
    <div class="col-md-12">
      <v-select v-model="selectedTags" :options="availableTags" taggable multiple></v-select>
    </div>
  </b-modal>
</template>
<script>
import moment from 'moment';
import { pl } from 'vuejs-datepicker/dist/locale';

import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/equipment.schema';
import { EquipmentResource } from '@/resources/equipment.resource';
import { EquipmentTypeResource } from '@/resources/equipmentType.resource';
import { TagResource } from '@/resources/tag.resource';

export default {
  mixins: [formMixin],
  props: {
    item: Object,
    addModal: Boolean,
    isEdit: Boolean
  },
  schema,
  data() {
    return {
      modal: false,
      id: null,
      equipment: {},
      types: [],
      selectedType: { value: null, text: '' },
      titleModal: '',
      tags: [],
      selectedTags: [],
      systemNumberNumber: null,
      systemNumberMask: null
    };
  },
  methods: {
    saveItem() {
      if (this.$schema.$validateAll().length === 0) {
        this.equipment = { ...this.$schema.$model, systemNumberMask: this.systemNumberMask, systemNumberNumber: this.systemNumberNumber };
        this.equipment.dateOfPurchase = this.equipment.dateOfPurchase ? moment(this.equipment.dateOfPurchase).toDate() : null;
        this.equipment.deleteDate = this.equipment.deleteDate ? moment(this.equipment.deleteDate).toDate() : null;
        if (this.id) {
          this.updateItem();
        } else {
          this.createItem();
        }
      }
    },
    async createItem() {
      try {
        const createdItem = await EquipmentResource.add(this.equipment, this.selectedTags);
        this.$schema.$reset();
        this.$emit('add', createdItem);
      } catch (error) {
        console.warn(error);
      }
    },
    async updateItem() {
      try {
        const updatedItem = await EquipmentResource.update(this.id, this.equipment, this.selectedTags);
        this.$schema.$reset();
        this.$emit('edited', updatedItem);
      } catch (error) {
        console.warn(error);
      }
    },
    async getTypes() {
      try {
        const types = await EquipmentTypeResource.listSimple();
        this.$set(this, 'types', types.map(type => ({ value: type.id, text: type.name, mask: type.mask })));
        if (this.item && this.item.type) {
          this.selectedType = this.types.find(e => e.value === this.item.type.id);
          this.$schema.$model.type = this.selectedType.value;
        }
      } catch (error) {
        console.warn(error);
      }
    },
    async setModelType(selectedType) {
      if (selectedType === null) {
        this.$schema.$model.type = null;
      } else {
        this.$schema.$model.type = selectedType.value;
        if (!this.item) {
          this.systemNumberMask = selectedType.mask;
          const lastNumber = await EquipmentResource.findLastMaskNumber(this.systemNumberMask);
          this.systemNumberNumber = lastNumber + 1;
          this.$schema.systemNumber.$value = selectedType.mask.replace(/\[NR\]/, this.systemNumberNumber);
        }
      }
    },
    async getTags() {
      try {
        const tags = await TagResource.list();
        this.tags.push(...tags.map(tag => tag.name));
      } catch (err) {
        console.warn(err);
      }
    }
  },
  beforeMount() {
    this.types = [];
    this.getTypes();
    this.getTags();
    this.modal = this.addModal;
    if (this.item) {
      this.$schema.dateOfPurchase.$value = this.item.dateOfPurchase;
      this.$schema.deleteReason.$value = this.item.deleteReason;
      this.$schema.deleteDate.$value = this.item.deleteDate;
      this.id = this.item.id;
      this.$schema.invoiceNumber.$value = this.item.invoiceNumber;
      this.$schema.positionNumber.$value = this.item.positionNumber;
      this.$schema.name.$value = this.item.name;
      if (this.item.price) {
        this.$schema.price.$value = this.item.price + '';
      } else {
        this.$schema.price.$value = '';
      }
      this.$schema.annotation.$value = this.item.annotation;
      this.$schema.deleted.$value = JSON.stringify(this.item.deleted);
      this.$schema.systemNumber.$value = this.item.systemNumber;
      this.$schema.serialNumber.$value = this.item.serialNumber;
      this.systemNumberMask = this.item.systemNumberMask;
      this.systemNumberNumber = this.item.systemNumberNumber;
      this.titleModal = this.item.name;
      this.systemModal = this.item.systemNumber;
      this.serialModal = this.item.serialNumber;
      if (this.item.tags) {
        this.selectedTags.push(...this.item.tags.map(tag => tag.name));
      }
    }
  },
  computed: {
    stateType() {
      return this.selectedType === null ? false : true;
    },
    invalidType() {
      if (this.selectedType === null) {
        return 'Wybierz rodzaj wyposażenia';
      } else {
        return '';
      }
    },
    validType() {
      return this.stateType === true ? '' : '';
    },
    availableTags() {
      return this.tags.filter(tag => !this.selectedTags.includes(tag));
    }
  }
};
</script>
<style>
.form-title {
  margin-left: 1.5em;
}
#title-modal {
  font-size: 1em;
}
#sub-title-modal {
  font-size: 0.66em;
}
.v-select-width {
  width: 90%;
}
.form-container-fluid {
  margin: 1em;
}
.form-batch-top {
  font-size: 1.15em;
  margin-left: 1.7em;
}
.form-batch {
  font-size: 1.15em;
  margin-left: 1.7em;
  margin-top: 3em;
}
.title-inline {
  display: inline-block;
}
</style>
